module.exports = __webpack_public_path__ + "9788f41e/img/settings-ico.a214628d.svg";